document.addEventListener('change', function(event) {
  var checkbox = event.target;
  if (!checkbox.matches('[data-express-checkout]')) return;

  var variantId = checkbox.getAttribute('data-variant-id');
  var quantity = parseInt(checkbox.getAttribute('data-quantity') || '1', 10);

  if (!variantId || quantity <= 0) {
    checkbox.checked = false;
    return;
  }

  function addToCart(id, qty, onDone, onError) {
    var bodyAdd = new URLSearchParams();
    bodyAdd.append('id', id);
    bodyAdd.append('quantity', String(qty));

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        onDone && onDone();
      } else {
        onError && onError(xhr);
      }
    };
    xhr.send(bodyAdd.toString());
  }

  function removeFromCart(id, onDone, onError) {
    var xhrCart = new XMLHttpRequest();
    xhrCart.open('GET', '/cart.js', true);
    xhrCart.setRequestHeader('Accept', 'application/json');
    xhrCart.onreadystatechange = function() {
      if (xhrCart.readyState !== 4) return;
      if (xhrCart.status < 200 || xhrCart.status >= 300) {
        onError && onError(xhrCart);
        return;
      }

      var cart;
      try {
        cart = JSON.parse(xhrCart.responseText);
      } catch (e) {
        onError && onError(e);
        return;
      }

      var lineToRemove = null;
      if (cart && cart.items && cart.items.length) {
        cart.items.forEach(function(item, index) {
          if (String(item.variant_id || (item.variant && item.variant.id)) === String(id)) {
            lineToRemove = index + 1;
          }
        });
      }

      if (!lineToRemove) {
        onDone && onDone();
        return;
      }

      var bodyUpdate = new URLSearchParams();
      bodyUpdate.append('line', String(lineToRemove));
      bodyUpdate.append('quantity', '0');

      var xhrChange = new XMLHttpRequest();
      xhrChange.open('POST', '/cart/change.js', true);
      xhrChange.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      xhrChange.setRequestHeader('Accept', 'application/json');
      xhrChange.onreadystatechange = function() {
        if (xhrChange.readyState !== 4) return;
        if (xhrChange.status >= 200 && xhrChange.status < 300) {
          onDone && onDone();
        } else {
          onError && onError(xhrChange);
        }
      };
      xhrChange.send(bodyUpdate.toString());
    };
    xhrCart.send(null);
  }

  if (checkbox.checked) {
    addToCart(
      variantId,
      quantity,
      function() {
        window.location.reload();
      },
      function() {
        checkbox.checked = false;
      }
    );
    return;
  }

  removeFromCart(
    variantId,
    function() {
      window.location.reload();
    },
    function() {
      checkbox.checked = true;
    }
  );
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.seExpressInCart) {
    function disableZapietAndUnlockCheckout() {
      var selectors = ['#storePickupApp', '#zapiet-checkout-methods', '.zapiet-widget-wrapper'];
      selectors.forEach(function(sel) {
        var els = document.querySelectorAll(sel);
        els.forEach(function(el) {
          el.style.display = 'none';
        });
      });
      var checkoutBtn = document.querySelector('input[name="checkout"]');
      if (!checkoutBtn) return;
      var clone = checkoutBtn.cloneNode(true);
      clone.removeAttribute('data-zapiet-checkout-button');
      if (checkoutBtn.id) {
        clone.id = checkoutBtn.id;
      }
      clone.disabled = checkoutBtn.disabled;
      checkoutBtn.parentNode.replaceChild(clone, checkoutBtn);
    }
    disableZapietAndUnlockCheckout();
    setTimeout(disableZapietAndUnlockCheckout, 500);
    setTimeout(disableZapietAndUnlockCheckout, 1500);
  }

  var hcAgreementPP = document.querySelector("#agreement");
  if (!hcAgreementPP) return;
  hcAgreementPP.addEventListener('change', function(e) {
    var checkoutBtn = document.querySelector("[name='checkout']");
    if (!checkoutBtn) return;
    if (e.target && e.target.checked) {
      checkoutBtn.removeAttribute("disabled");
    } else {
      checkoutBtn.setAttribute("disabled", true);
    }
  });
});
